import { lightColors } from '@/plugins/colors/base/baseColorsLight'

const textTokensLight = {
  'text-primary': lightColors.gray['900'],
  'text-primary-invert': lightColors.gray.white,
  'text-secondary': lightColors.gray['500'],
  'text-caption': lightColors.gray['400'],
  'text-additional': lightColors.gray['300'],
  'text-disabled': lightColors.gray['300'],
  'text-white': lightColors.gray.white,
  'text-brand': lightColors.brand['500'],
  'text-error': lightColors.red['700'],
  'text-success': lightColors.green['700'],
  'text-warning': lightColors.orange['700'],
  'text-info': lightColors.blue['700'],
  'old-text-secondary': lightColors.oldGrey.darken1,
}

export default textTokensLight
